import { render, staticRenderFns } from "./ProjectModal_Details.vue?vue&type=template&id=080acc7d&scoped=true&"
import script from "./ProjectModal_Details.vue?vue&type=script&lang=js&"
export * from "./ProjectModal_Details.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModal_Details.vue?vue&type=style&index=0&id=080acc7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080acc7d",
  null
  
)

export default component.exports